export const SET_DATA_FOR_CHECK = 'SET_DATA_FOR_CHECK';
export const SET_INIT_TITLE = 'SET_INIT_TITLE';
